// src/UserMenu.js
import React from "react";
import { Avatar, IconButton, Menu, MenuItem, Typography, Divider, Box } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import axios from "axios";

class UserMenu extends React.Component {
  state = { anchorEl: null };

  // FIX: Logic changed from "Open" to "Toggle"
  handleProfileClick = (event) => {
    if (this.state.anchorEl) {
      this.handleMenuClose();
    } else {
      this.setState({ anchorEl: event.currentTarget });
    }
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  // Always-visible "Switch to mobile" — no device/preferDesktop gate. Clear the
  // switched-to-desktop flag (going to mobile means "I want mobile") so the entry-
  // redirect isn't left suppressed, then go to the mobile app.
  handleSwitchToMobile = () => {
    try { localStorage.removeItem("preferDesktop"); } catch (e) { /* ignore */ }
    window.location.href = "/m";
  };

  handleLogout = () => {
    axios
      .post("/api/user/logout/")
      .then(() => {
        window.location.href = "/";
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  };

  render() {
    const { anchorEl } = this.state;
    const { user } = this.props;

    const isOpen = Boolean(anchorEl);

    return (
      <>
        {/* We use Box + IconButton to ensure it handles clicks strictly */}
        <IconButton 
            onClick={this.handleProfileClick} 
            size="small"
            aria-controls={isOpen ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={isOpen ? 'true' : undefined}
            sx={{ ml: 1 }} // Add a little margin left
        >
          <Avatar
            sx={{
              width: 38, // Slightly smaller to fit header better
              height: 38,
              bgcolor: "#0497b2",
              fontWeight: "bold",
              fontSize: 14,
              border: isOpen ? "2px solid #0497b2" : "2px solid transparent", // Visual feedback when open
              transition: "border 0.2s ease"
            }}
          >
            {user.name
              ? user.name
                  .split(" ")
                  .map((part) => part[0].toUpperCase())
                  .slice(0, 2)
                  .join("")
              : "U"}
          </Avatar>
        </IconButton>

        <Menu
          id="account-menu"
          anchorEl={anchorEl}
          open={isOpen}
          onClose={this.handleMenuClose}
          onClick={this.handleMenuClose} // Close menu when an item is clicked
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          slotProps={{
            paper: {
              elevation: 4,
              sx: {
                mt: 1.5,
                borderRadius: 4,
                minWidth: 200,
                overflow: 'visible',
                '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 20,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
              }
            }
          }}
        >
          <MenuItem disabled sx={{ opacity: "1 !important" }}>
            <Box>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color: 'text.primary'}}>
                {user.name || "User"}
              </Typography>
              <Typography variant="body2" color="text.secondary">{user.company || ""}</Typography>
            </Box>
          </MenuItem>
          <Divider />
          <MenuItem
            onClick={() => {
              this.handleMenuClose();
              this.handleSwitchToMobile();
            }}
            sx={{ py: 1.5 }}
          >
            <PhoneIphoneIcon fontSize="small" style={{ marginRight: 12 }} />
            Switch to mobile
          </MenuItem>
          <MenuItem
            onClick={() => {
              this.handleMenuClose();
              this.handleLogout();
            }}
            sx={{ py: 1.5 }}
          >
            <LogoutIcon fontSize="small" style={{ marginRight: 12 }} />
            Logout
          </MenuItem>
        </Menu>
      </>
    );
  }
}

export default UserMenu;